import { computed } from 'mobx';
import ApiModel     from './globals/ApiModel';

export default class AdvertiserShowModel extends ApiModel {
  static get path() {
    return '/backend/advertiser_shows/{?id}';
  }

  @computed
  get counter() {
    return this.get('counter', 0);
  }
}
